import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from "@angular/router";

@Injectable()
export class LoginService
{
    constructor(private http: HttpClient, private router: Router, @Inject('BASE_URL') private baseUrl: string)
    {

    }

    // login
    login(loginViewModel: any)
    {
        this.logout(false);
        return this.http.post(this.baseUrl + 'api/shared/login/login', loginViewModel);
    }

    // logout
    logout(redirectToLogin: boolean = true)
    {
        return this.http.post(this.baseUrl + 'api/shared/login/logout', {}).subscribe(() =>
        {
            // removing access_token
            localStorage.removeItem("session_prop");
            localStorage.removeItem("access_token");

            // redirect to login
            if (redirectToLogin)
                this.router.navigate(['login']);
        });
    }

    // forgot password
    forgotPassword(email: string)
    {
        return this.http.post(this.baseUrl + 'api/shared/login/forgotPassword', { email: email });
    }

    // reset password
    resetPassword(idUser: string, token: string, newPassword: string)
    {
        return this.http.post(this.baseUrl + 'api/shared/login/resetPassword', { idUser: idUser, token: token, password: newPassword });
    }

    // reset password (internal)
    resetPasswordInternal(idUser: string, newPassword: string)
    {
        return this.http.post(this.baseUrl + 'api/shared/login/resetPasswordInternal', { idUser: idUser, password: newPassword });
    }
}